import { DependencyList, useCallback, useEffect } from 'react';
import { type Listener, eventBus } from './eventBus';
import type { AppEvent } from './events';

export const useListener = <T extends AppEvent['type']>(
  type: T,
  listener: Listener<Extract<AppEvent, { type: T }>>,
  deps: DependencyList,
) => {
  const listen = eventBus((state) => state.listen);
  const flushEvents = eventBus((state) => state.flushEvents);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const cb = useCallback(listener, [listener, ...deps]);

  useEffect(() => {
    flushEvents(type).forEach((event) =>
      cb(event as Extract<AppEvent, { type: T }>),
    );
    return listen((event) => cb(event as Extract<AppEvent, { type: T }>));
  }, [type, cb, listen, flushEvents]);
};
